module.exports = __webpack_public_path__ + "Frame401-e2b8d6fc.webp";